import {request} from "./request";

export function getClubList() {
  return request({
    url: 'club/ClubList'
  })
}

export function GetClubDetailById(id) {
  return request({
    url: 'club/GetClubDetailById',
    params: {
      id
    }
  })
}

export function GetClubInfoById(id) {
  return request({
    url: 'club/GetClubInfoById',
    params: {
      id
    }
  })
}

export function DelClubById(id) {
  return request({
    url: 'club/DelClubById',
    params: {
      id
    }
  })
}

export function AddClub(ClubName, Location, tecnameandnum, maxp, introduction, startTime, createDate) {
  return request({
    url: 'club/AddClub',
    params: {
      ClubName,
      Location,
      tecnameandnum,
      maxp,
      introduction,
      startTime,
      createDate
    }
  })
}

export function AddClubAdmin(cid, sid, sName, sNum) {
  return request({
    url: 'club/AddClubAdmin',
    params: {
      cid, sid, sName, sNum
    }
  })
}

export function GetClubAdminList(cid) {
  return request({
    url: 'club/GetClubAdminList',
    params: {
      cid
    }
  })
}

export function DelClubAdmin(cid, sid) {
  return request({
    url: 'club/DelClubAdmin',
    params: {
      cid, sid
    }
  })
}

export function ModifyClub(id, title, tId, tName, tNum, tGender, location, des, maxp, startTime) {
  return request({
    url: 'club/ModifyClub',
    params: {
      id, title, tId, tName, tNum, tGender, location, des, maxp, startTime
    }
  })
}

export function GetClubCountById(cid) {
  return request({
    url: 'club/GetClubCountById',
    params: {
      cid
    }
  })
}

export function GetStatisticsById(cid, years, months, days) {
  return request({
    url: 'club/GetStatisticsById',
    params: {
      cid, years, months, days
    }
  })
}

export function SelectClub(cid) {
  return request({
    url: 'student/SelectClub',
    params: {
      cid,
    }
  })
}

export function GetClubDetailDownLoad(cid) {
  return request({
    method: 'post',
    url: 'club/GetClubDetailDownLoad',
    params: {cid},
    responseType: 'blob'
  })
}

export function CountStudentByConditions(grade, level) {
  return request({
    url: 'club/CountStudentByConditions',
    params: {
      grade, level,
    }
  })
}

export function DelStudentByConditions(grade, level) {
  return request({
    url: 'club/DelStudentByConditions',
    params: {
      grade, level,
    }
  })
}
